import { Inject } from '@odinjs/odin';

import { FormAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

interface Data {
  dsMaterial: string;
}

@Controller({ fragment: 'anexo-item-prod-mat' })
export default class AnexoItemProdMatController extends BaseController {

  @Inject('panel-tiss-opme')
  private panelTissOpme: PanelAPI;

  @Inject('panel-tiss-quimio')
  private panelTissQuimio: PanelAPI;

  @Inject('form-tiss-opme')
  private formTissOpme: FormAPI;

  @Inject('form-tiss-quimio')
  private formTissQuimio: FormAPI;

  @OnMount({ target: 'layout-anexo-item-prod-mat' })
  public onMountLayoutAutorizacaoDadosGuia(): void {
    const ieTipoAnexo = this.context.get('ieTipoAnexo') as string;

    if (ieTipoAnexo == 'QU') {
      this.panelTissOpme.setVisible(false);
    } else if (ieTipoAnexo == 'OP') {
      this.panelTissQuimio.setVisible(false);
    }

  }

  @OnAfterFetch({ target: ['fetch-tiss-quimio', 'fetch-tiss-opme'] })
  public onAfterFetch(event: FetchEvent): void {
    const data = event.data as Data;

    if (!data) return;

    const { dsMaterial } = data;
    const ieTipoAnexo = this.context.get('ieTipoAnexo') as string;

    if (ieTipoAnexo == 'QU') {
      this.formTissQuimio.setTitle(dsMaterial || '');
    } else if (ieTipoAnexo == 'OP') {
      this.formTissOpme.setTitle(dsMaterial || '');
    }

  }

}
